/* 🤖 this file was generated by svg-to-ts */
export const kzIconsHelp: {
  name: 'help';
  data: string;
} = {
  name: 'help',
  data: `<svg viewBox="0 0 20 20"><g stroke="currentColor" stroke-width="1.2" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M6.967 7.341c1.069-2.074 4.246-2.843 5.5-1.588 2.51 2.508-1.881 3.136-2.45 5.407-.105.262-.055 1.27-.055 1.27M9.96 14.765v.396"/><path d="M18.802 9.698a9.103 9.103 0 0 1-9.104 9.104A9.103 9.103 0 0 1 .594 9.698 9.103 9.103 0 0 1 9.698.594a9.103 9.103 0 0 1 9.104 9.104Z"/></g></svg>`
};
